export default "__VITE_ASSET__Ds6Ftx3r__"